import { animate, style, transition, trigger } from "@angular/animations";
import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { BlockUIModule } from "ng-block-ui";
import { ButtonModule } from "primeng/button";
@Component({
  selector: "app-payment-methods",
  standalone: true,
  imports: [CommonModule, ButtonModule, BlockUIModule],
  animations: [
    trigger("fadeIn", [
      transition(":enter", [
        style({ opacity: 0 }),
        animate("200ms ease-in", style({ opacity: 1 })),
      ]),
      transition(":leave", [animate("200ms ease-out", style({ opacity: 0 }))]),
    ]),
  ],
  templateUrl: "./payment-methods.component.html",
  styleUrl: "./payment-methods.component.scss",
})
export class PaymentMethodsComponent {
  isModalOpen = false;
  isStep1 = true;
  isStep2 = false;
  isStep3 = false;
  openModal() {
    this.isModalOpen = true;
  }

  addPaymentMethod() {}

  closeModal() {
    this.isModalOpen = false;
  }
}
